module.exports = __webpack_public_path__ + "img/stock7.701c20a3.png";